// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__Q8APK","messages":"Chat_messages__9OArQ","dateDivider":"Chat_dateDivider__1NYWt"};